import * as Sentry from '@sentry/react';

/**
 * Initialize Sentry for frontend error tracking
 * Only enabled in production and staging environments
 */
export const initializeSentry = (): void => {
    const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
    const environment = import.meta.env.MODE;

    // Only initialize in production or staging if DSN is provided
    if ((environment === 'production' || environment === 'staging') && sentryDsn) {
        Sentry.init({
            dsn: sentryDsn,
            environment,

            // Performance Monitoring
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration({
                    maskAllText: false,
                    blockAllMedia: false,
                }),
            ],
            
            // Trace propagation targets (for distributed tracing)
            tracePropagationTargets: ['localhost', /^https:\/\/.*\.sorigin\.app/],

            // Performance traces
            tracesSampleRate: environment === 'production' ? 0.1 : 1.0,

            // Session Replay
            replaysSessionSampleRate: 0.1, // Sample 10% of sessions
            replaysOnErrorSampleRate: 1.0, // Capture 100% of sessions with errors

            // Release tracking (optional)
            release: import.meta.env.VITE_SENTRY_RELEASE,
        });

        console.log(`Sentry initialized for ${environment} environment`);
    } else if (environment === 'development') {
        console.log('Sentry not initialized (development mode)');
    } else {
        console.log('Sentry not initialized (missing VITE_SENTRY_DSN)');
    }
};

export default Sentry;
